/* MELYSIUM: Wischen mit dem Finger für Slider ohne eigene Touch-Steuerung (15.10.2026).
   Tim: alle Slides sollen sich gleich anfühlen wie die wischbare Bildreihe der
   melysium Manufaktur. Betrifft den Vorher-Nachher-Slider (sections/vorhernachher.liquid):
   Der Slider bewegt sich beim Wischen mit dem Finger mit, danach wird sein eigener
   Pfeil-Knopf gedrückt, damit Endlos-Schleife und Punkte korrekt bleiben.
   Eingebunden in snippets/meta-tags.liquid. */
(function () {
  function einrichten(huelle) {
    if (huelle.dataset.mlysSwipe) return;
    var spur = huelle.querySelector('[data-slider-track]');
    var bereich = huelle.parentElement;
    var zurueck = bereich && bereich.querySelector('[data-prev]');
    var weiter = bereich && bereich.querySelector('[data-next]');
    if (!spur || !zurueck || !weiter) return;
    huelle.dataset.mlysSwipe = '1';
    huelle.style.touchAction = 'pan-y';

    var startX = 0, startY = 0, dx = 0, aktiv = false, richtung = null, basis = '';

    huelle.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY; dx = 0;
      aktiv = true; richtung = null;
      basis = spur.style.transform || '';
    }, { passive: true });

    huelle.addEventListener('touchmove', function (e) {
      if (!aktiv) return;
      var t = e.touches[0];
      var mx = t.clientX - startX, my = t.clientY - startY;
      if (richtung === null) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        richtung = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
      }
      if (richtung !== 'x') return;
      e.preventDefault();
      dx = mx;
      spur.style.transition = 'none';
      spur.style.transform = basis + ' translateX(' + dx + 'px)';
    }, { passive: false });

    function ende() {
      if (!aktiv) return;
      aktiv = false;
      if (richtung !== 'x') return;
      spur.style.transition = 'transform 0.3s ease';
      spur.style.transform = basis;
      if (dx < -40) weiter.click();
      else if (dx > 40) zurueck.click();
    }
    huelle.addEventListener('touchend', ende);
    huelle.addEventListener('touchcancel', ende);
  }

  function start() {
    document.querySelectorAll('[class*="before-after-slider-wrapper-"]').forEach(einrichten);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
